const getKCoefficient = (rad: number): number =>
  +Math.tan(rad).toFixed(5);

export default getKCoefficient;
